import { fork, takeEvery, put, call } from 'redux-saga/effects';
import types from './types';
import ChugActions from './actions';

function* handleFetchState(context) {
  const { chugApiService } = context;
  const state = yield call(chugApiService.loadState);

  yield put(ChugActions.setState(state));
}

function* watchFetchState(context) {
  yield takeEvery(types.FETCH_STATE, handleFetchState, context);
}

export default (context) => [fork(watchFetchState, context)];
